import React, { useEffect, useState } from 'react'

import Stack from '@mui/material/Stack'
import { ValueNarrativeCategoryTabsWrapper } from './components/ValueNarrativeCategoryTabs/ValueNarrativeCategoryTabsWrapper'
import { ValueNarrativesHeader } from './components/ValueNarrativesHeader/ValueNarrativesHeader'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import { useAuth0 } from '../../contexts/auth0-context'
import { useValueNarratives } from './useValueNarratives'
import { Fade } from '@mui/material/'
import ValueNarrativeActionsProvider from './providers/ValueNarrativeActionsProvider'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useStrategy } from '../../shared/hooks/useStrategy'
import ValueMessageActionsProvider from '../ValueMessages/providers/ValueMessageActionsProvider'

const ValueNarrativesView = () => {
    const strategy = useStrategy()

    const { isAuthenticated, getTokenSilently } = useAuth0()
    const [isAIEnabled, setIsAIEnabled] = useState(false)

    const authenticateAI = async () => {
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        let incomingOrg = await callAPI(
            endpoints.getOrganizationById.url + strategy?.organizationId,
            endpoints.getOrganizationById.method,
            token
        )
        if (incomingOrg.success && incomingOrg?.data?.isAIEnabled) {
            setIsAIEnabled(true)
        }
    }

    useEffect(() => {
        if (isAuthenticated) {
            authenticateAI()
        }
    }, [isAuthenticated])

    const {
        isCategoriesDataReady,
        dataWithoutPseudoCategories,
        dataWithPseudoCategories,
        selectedCategory,
        selectedNarrative,
        handleSelectCategory,
        handleSelectNarrative,
        handleSelectMessage,
    } = useValueNarratives()
    return (
        <ValueNarrativeActionsProvider>
            <ValueMessageActionsProvider>
                <Fade in timeout={1000}>
                    <Stack p={2} gap={1} flex={1}>
                        <Switch>
                            <Route exact path="/narratives/categories/:categoryId" component={() => null} />
                            <Route
                                exact
                                path="/narratives/categories/:categoryId/narratives/:narrativeId"
                                component={() => null}
                            />
                            <Route
                                exact
                                path="/narratives/categories/:categoryId/narratives/:narrativeId/messages/:messageId"
                                component={() => null}
                            />

                            <Redirect
                                from="/narratives/categories/:categoryId/narratives/:narrativeId/messages/:messageId/*"
                                to="/narratives/categories/:categoryId/narratives/:narrativeId/messages/:messageId"
                            />
                            <Redirect
                                from="/narratives/categories/:categoryId/narratives/:narrativeId/*"
                                to="/narratives/categories/:categoryId/narratives/:narrativeId"
                            />
                            <Redirect
                                from="/narratives/categories/:categoryId/*"
                                to="/narratives/categories/:categoryId"
                            />

                            <Redirect from="/narratives/*" to="/narratives" />
                        </Switch>
                        {isCategoriesDataReady && (
                            <>
                                <ValueNarrativesHeader
                                    selectedNarrative={selectedNarrative}
                                    selectedCategory={selectedCategory}
                                    categories={dataWithoutPseudoCategories}
                                />
                                <ValueNarrativeCategoryTabsWrapper
                                    isAIEnabled={isAIEnabled}
                                    dataWithPseudoCategories={dataWithPseudoCategories}
                                    dataWithoutPseudoCategories={dataWithoutPseudoCategories}
                                    selectedCategory={selectedCategory}
                                    selectedNarrative={selectedNarrative}
                                    handleSelectCategory={handleSelectCategory}
                                    handleSelectNarrative={handleSelectNarrative}
                                    handleSelectMessage={handleSelectMessage}
                                />
                            </>
                        )}
                    </Stack>
                </Fade>
            </ValueMessageActionsProvider>
        </ValueNarrativeActionsProvider>
    )
}

export default ValueNarrativesView
